import { Link } from "react-router-dom";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export function AuthShell({ children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-[1.1fr_1fr] bg-background">
      <div className="relative hidden lg:block overflow-hidden">
        <img src="/login-bg.jpg" alt="Hardware store shelves" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-slate-950/55" />
        <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-slate-950 to-transparent" />
        <div className="absolute bottom-0 left-0 p-12 xl:p-16 space-y-5 max-w-xl">
          <div className="label-mono !text-amber-400">Three depots · One ledger</div>
          <h2 className="font-display text-5xl xl:text-6xl font-extrabold uppercase leading-[0.95] tracking-tight">
            Every bolt, bag &amp; dollar — accounted for.
          </h2>
          <p className="text-slate-300 text-base">Stock in, sales, expenses and cashflow across all your depots, with an evening closing report ready to print.</p>
        </div>
      </div>
      <div className="flex items-center px-6 py-12 sm:px-12 lg:px-16 xl:px-24">
        <div className="rise w-full max-w-md space-y-8">
          <Link to="/login" className="flex items-center gap-2" data-testid="auth-brand-link">
            <div className="h-9 w-9 rounded bg-amber-500 grid place-items-center text-slate-950 font-display font-extrabold text-xl">M</div>
            <span className="font-display text-xl sm:text-2xl font-bold uppercase leading-tight tracking-wide" data-testid="auth-brand-name">MATWIGA ENTERPRISES LEDGER</span>
          </Link>
          {children}
        </div>
      </div>
    </div>
  );
}

export function AuthHeading({ title, subtitle }) {
  return (
    <div className="space-y-2">
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold uppercase tracking-tight">{title}</h1>
      {subtitle && <p className="text-sm text-slate-400">{subtitle}</p>}
    </div>
  );
}

export function AuthField({ id, label, type = "text", value, onChange, testid, autoComplete, minLength, right }) {
  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between">
        <Label htmlFor={id} className="label-mono">{label}</Label>
        {right}
      </div>
      <Input id={id} type={type} required autoComplete={autoComplete} minLength={minLength} value={value}
        onChange={(e) => onChange(e.target.value)} className="h-11 bg-slate-900" data-testid={testid} />
    </div>
  );
}

export function AuthAlert({ tone = "error", children, testid }) {
  const cls = tone === "error" ? "border-rose-500/30 bg-rose-500/10 text-rose-300" : "border-emerald-500/30 bg-emerald-500/10 text-emerald-300";
  return <div className={`rounded-md border px-3 py-2.5 text-sm ${cls}`} data-testid={testid}>{children}</div>;
}
